// components/common/MToaster.tsx
import React from "react";
import { Snackbar, Alert, IconButton, Slide } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { hideToast } from "../../../application/features/common/toasterSlice";
import { Icon } from "@iconify/react";
const SlideTransition = (props) => {
    return React.createElement(Slide, Object.assign({}, props, { direction: "down" }));
};
const MToaster = () => {
    const dispatch = useDispatch();
    const { open, message, severity } = useSelector((state) => state.toaster);
    const handleClose = () => {
        dispatch(hideToast());
    };
    return (React.createElement(Snackbar, { open: open, autoHideDuration: 4000, onClose: handleClose, anchorOrigin: { vertical: "top", horizontal: "right" }, TransitionComponent: SlideTransition },
        React.createElement(Alert, { severity: severity, onClose: handleClose, variant: "filled", sx: {
                width: "100%",
                boxShadow: 3,
                minWidth: "280px",
                maxWidth: "400px",
                fontSize: "0.9rem",
            }, action: React.createElement(IconButton, { "aria-label": "close", color: "inherit", size: "small", onClick: handleClose },
                React.createElement(Icon, { icon: "eva:close-outline", width: "24", height: "24" })) }, message)));
};
export default MToaster;
